<template>
  <b-modal id="bv-modal-input"
           @hide="onHide"
           @ok="onOk"
           :ok-disabled="!field.isValid || !field.isChecked"
           :ok-variant="okVariant"
           :ok-title="okTitle"
           :cancel-title="cancelTitle"
           :cancel-variant="cancelVariant"
  >
    <template v-slot:modal-title>
      {{ title }}
    </template>
    <div class="d-block text-center">
      <b-form-group label-cols="12" class="text-left" :label="message" label-for="line-input-dialog-inp">
        <b-form-input id="line-input-dialog-inp" v-model="field.value" :maxlength="maxLength"></b-form-input>
        <small class="pt-1 form-text text-danger">{{ field.errorMessage || '&nbsp' }}</small>
      </b-form-group>
    </div>
  </b-modal>

</template>

<script>
import ValidatedField from "@/validation/ValidatedField";

export default {
  name: "InputDialog",
  async beforeMount() {
  },
  methods: {
    async onOk(ev) {
      if (this.resolve != null) {
        this.result = this.field.value;
        this.resolve(this.result);
        this.resolve = null;
      }
    },
    async onHide(ev) {
      if (this.resolve != null) {
        this.resolve(null);
        this.resolve = null;
      }
    },
    reset(options = {}) {
      this.field = new ValidatedField();
      this.result = null;
      this.resolve = null;
      this.okVariant = options?.okVariant ?? 'plm-primary';
      this.cancelVariant = options?.cancelVariant ?? 'plm-secondary';
      this.okTitle = options?.okTitle;
      this.cancelTitle = options?.cancelTitle;
    },

  },

  watch: {
    'field.isValid': async function (newVal, oldVal) {
      if (this.field.isValid) {
        this.field.errorMessage = "";
      }
    },
  },

  data: () => ({
    title: "title",
    message: "message",
    resolve: null,
    field: new ValidatedField(),
    result: null,
    maxLength: 500,
    okVariant: 'plm-primary',
    cancelVariant: 'plm-secondary',
    okTitle: null,
    cancelTitle: null

  })
}
</script>
